//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    editedDate: "",
    date: "",
    menu: false,
  }),
  methods: {
    emitDateUpdated() {
      this.date = this.editedDate;
      this.$emit("dateUpdated", this.date);
    },
  },
  watch: {
    date: function () {
      this.emitDateUpdated();
    }
  }
};
